const data: string = "<ui-view></ui-view>";
export default data